import {ActionTree} from "vuex";
import {OriginatorRulesState} from "@/store/rules/originator_rules/types";
import {RootState} from "@/store/types";
import axios from "axios";
import {OriginatorRuleItem} from "@/store/rules/originator_rules/types";

export const actions: ActionTree<OriginatorRulesState, RootState> = {
  getOriginatorRules: ({commit, dispatch}, data:any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/${data.transport}/set_originator`, params: data.filter})
        .then(resp => {
            if (data?.filter.page_number > 1) {
              commit("pushOriginatorRules", resp.data?.originator_rules);
            } else {
              commit('setOriginatorRules', resp.data?.originator_rules);
            }
          resolve(resp.data?.originator_rules)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getOriginatorRuleItem: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/${data.transport}/set_originator/${data.id}`})
        .then(resp => {
          let originatorRuleItem = <OriginatorRuleItem>resp.data
          originatorRuleItem.id = data.id;
          commit('setOriginatorRuleItem', originatorRuleItem);
          resolve(originatorRuleItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  saveOriginatorRule: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.item.id ? 'put' : 'post',
        url: `/acapi/${data.transport}/set_originator/${data.item.id ?? ''}`,
        data: data.item
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getOriginatorRules', data);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deleteOriginatorRule: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/${data.transport}/set_originator/${data.item.id}`
      })
        .then((resp:any) => {
          dispatch('getOriginatorRules', data);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
}
